import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { BsChevronDown } from "react-icons/bs";
import TimecodeBadge from "./TimecodeBadge";

const ChaptersBlock = ({ chapters, on_seek }) => {
  const { t } = useTranslation();
  const [is_expanded, set_is_expanded] = useState(true);
  if (!Array.isArray(chapters) || chapters.length === 0) return null;
  return (
    <div className="border border-gray-200 rounded-xl overflow-hidden">
      <button
        type="button"
        onClick={() => set_is_expanded(!is_expanded)}
        className={`w-full flex items-center justify-between px-4 py-3 bg-gray-50 hover:bg-gray-100 transition-colors ${
          is_expanded ? "border-b border-gray-200" : ""
        }`}
      >
        <div className="flex items-center gap-2">
          <span className="text-base">🎬</span>
          <span className="font-medium text-base">{t("Déroulé d'appel")}</span>
        </div>
        <BsChevronDown
          className={`text-gray-400 transition-transform ${is_expanded ? "rotate-180" : ""}`}
          size={16}
        />
      </button>
      {is_expanded && (
        <div className="p-5 flex flex-col gap-4">
          {chapters.map((chapter, idx) => (
            <div
              key={`c-${idx}`}
              className="flex gap-3"
            >
              <div className="flex flex-col items-center">
                <div className="flex justify-center items-center w-7 h-7 rounded-full bg-primary/10 text-primary text-xs font-bold shrink-0">
                  {idx + 1}
                </div>
                {idx < chapters.length - 1 && <div className="w-px flex-1 bg-gray-200 mt-1" />}
              </div>
              <div className="flex-1 pb-1">
                {(chapter?.title || Number.isFinite(chapter?.start)) && (
                  <div className="flex items-center gap-2 mb-1">
                    {chapter?.title && (
                      <span className="font-semibold text-sm text-gray-900">{chapter.title}</span>
                    )}
                    {on_seek && Number.isFinite(chapter?.start) && (
                      <TimecodeBadge
                        seconds={chapter.start}
                        on_seek={on_seek}
                      />
                    )}
                  </div>
                )}
                {Array.isArray(chapter?.points) && chapter.points.length > 0 && (
                  <ul className="list-disc pl-5 text-sm text-gray-700 leading-relaxed space-y-1">
                    {chapter.points.map((point, pi) => (
                      <li key={`c-${idx}-p-${pi}`}>{point}</li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ChaptersBlock;
